import React from "react";

const Experience = ({experienceRef}) => {
    return (
        <div ref={experienceRef} className="md:mt-20 md:p-0 Experience p-[20px] mt-10">
            <p className="md:text-6xl font-bold text-4xl">Job Experience<span className="text-[#ffd739]">_</span></p>
            
            <div className="flex space-x-0 flex flex-col mt-0   md:flex md:flex-row md:space-x-10">
                <div className="amihan md:mt-4 mt-7 grow md:w-[50%] w-full">
                    <p className="md:text-2xl text-under font-semibold  text-xl">AMIHAN SOLUTION</p>
                    <p className="md:text-xl mt-1  text-lg">2022 - PRESENT</p>
                    <p className="md:text-xl mt-1  text-lg">Fullstack Magento Developer</p>
                    <div className="flex flex-row mt-4">
                        <div className="h-22 bg-[#ffd739] w-[10px] mr-4 hidden md:block"></div>
                        <p className="md:text-xl text-justify mt-1  text-lg">I have managed four e-commerce sites using Magento 2. My tasks mostly involve the frontend and less often the backend, but I am capable of working proficiently in both areas for your site.</p>
                    </div>
                </div>
                <div className="lumenvo md:mt-4 mt-7 grow md:w-[50%] w-full">
                    <p className="md:text-2xl text-under font-semibold text-xl">Lumenvo (Freelance)</p>
                    <p className="md:text-xl mt-1  text-lg">2021 - 2022</p>
                    <p className="md:text-xl mt-1  text-lg">Fullstack Magento Developer</p>
                    <div className="flex flex-row mt-4">
                        <div className="h-22 bg-[#ffd739] w-[10px] mr-4 hidden md:block"></div>
                        <p className="md:text-xl  text-justify mt-1  text-lg">I have maintained five ecommerce sites with Magento 2. My task mostly invlove with upgradingn Magento version and creating new plugins for necessary websites. </p>
                    </div>
                </div>
            </div>

            <div className="flex space-x-0 flex flex-col mt-0   md:flex md:flex-row md:space-x-10 md:mt-20">
                <div className="scigsi grow md:w-[50%] md:mt-0 w-full mt-7">
                    <p className="md:text-2xl text-under font-semibold text-xl">SCI Glbal Services INC. (SCIGSI)</p>
                    <p className="md:text-xl mt-1 text-lg">2019 - 2021</p>
                    <p className="md:text-xl mt-1 text-lg">Fullstack PHP Developer</p>
                    <div className="flex flex-row mt-4">
                        <div className="h-22 bg-[#ffd739] w-[10px] mr-4 hidden md:block"></div>
                        <p className="md:text-xl text-justify mt-1  text-lg">I have work with Magento 2 and 1 as lead developer for 1 project. I have also maintained a Codeigniter web application. I have also maintainted an ASP website. I have also managed and maintained wordpress sites.</p>
                    </div>
                </div>
                <div className="ptbcsi grow md:w-[50%] md:mt-0 w-full mt-7">
                    <p className="md:text-2xl text-under font-semibold  text-xl">Premium Tech Building Construction System Inc. (PTBCSI)</p>
                    <p className="md:text-xl mt-1 text-lg">2018 - 2019</p>
                    <p className="md:text-xl mt-1 text-lg">Programmer</p>
                    <div className="flex flex-row mt-4">
                        <div className="h-22 bg-[#ffd739] w-[10px] mr-4 hidden md:block"></div>
                        <p className="md:text-xl  text-justify mt-1 text-lg">I worked with C# and ASP to create a desktop application. I managed and maintained the web applications using Codeigniter and Laravel framework. I have also asigned to work with Xamarin when I was a trainee.</p>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default Experience;